import React, {useEffect, useMemo, useState} from "react";
import {useHistory, useLocation, useParams} from "react-router-dom";
import {PollApiCalls} from "../../apis/PollApiCalls";
import {UserApiCalls} from "../../apis/UserApiCalls";
import YuJaGeneralAlert from "../../components/modals/YuJaGeneralAlert";
import {useLocalStorageNew} from "../../hooks/useLocalStorageNew";
import {usePPTWebView} from "../../hooks/usePPTWebView";
import {
    ACTIVITY_EDITOR_VIEW, ATTENDANCE_DEFAULT_TITLE,
    AUDIENCE_RESTRICTION, DATE_TO_REPLACE,
    DELETE_ACTIVITY, DELETE_ACTIVITY_MODAL_BODY, DRAFT_TEXT,
    HOME_PATH, MODAL_CANCEL_TEXT, MODAL_DELETE_TEXT,
    POLL_SHARE_MODE,
    POLL_TITLE_LENGTH,
    POLL_TYPE, QUESTION, QUESTION_MAX_POINTS,
    QUESTION_TYPES,
    SYNC_LMS_OPTIONS,
    USER_SETTINGS
} from "../../utils/constants";
import {
    generateDefaultAttendanceTitle, generateDefaultPollTitle, getActivityAudienceRestriction,
    getDefaultUserSettings, getQuestionWeightage, getShortName, isShareByQuestionActivity,
    notifyError, removePrefix, removePrefixNew,
    transferUserSettings,
    updateCreateMode,
    validateText
} from "../../utils/helpers";
import {
    addQuestion, FormatDate,
    questionError, setBlankRestriction,
    trimLineBreakerInQuestion,
    trimQuestion
} from "../../utils/questionUtils";
import {
    ACTIVITY_TITLE_ERROR,
    GRADE_SCHEMA_MISSING_ERROR,
    QUESTION_MAX_POINTS_ERROR, SELECT_COURSE_MESSAGE
} from "../../utils/toast-message-constants";

import {useImageLoaderManager} from "../../hooks/useImageLoaderManager";
import useNavigationGuard from "../../hooks/useNavigationGuard";
import classes from "../CreateQuizPage/ActivityEditor.module.css";
import ActivityEditorTitleContainer from "../CreateQuizPage/ActivityEditorTitleContainer";
import ActivityEditorDashboard from "../CreateQuizPage/ActivityEditorDashboard";
import ActivityEditorMainView from "../CreateQuizPage/ActivityEditorMainView";
import PPTActivitySaved from "./PPTActivitySaved";
import {PublicApiCall} from "../../apis/PublicApiCall";
import {CourseApiCalls} from "../../apis/CourseApiCalls";
import {useSynLMSConfiguration} from "../../hooks/useSynLMSConfiguration";
import {ReportApiCalls} from "../../apis/ReportApiCalls";
import ActivityEditorImportQuestions from "../CreateQuizPage/ActivityEditorImportQuestions";


export default function PPTEditActivityPage() {
    const {pollKey} = useParams();
    const {parseToken,} = usePPTWebView();
    const [userSettings, setUserSettings] = useState(getDefaultUserSettings());
    const [pollCode, setPollCode] = useState("");
    const {updateAndPublish, getPollDataFromKey, softDeleteDraftPoll} = PollApiCalls();
    const {resolveShortName} = PublicApiCall();
    const {loadUser} = UserApiCalls();
    const {getCourseByUser} = CourseApiCalls();
    const {takeScreenshotsNew, warmUpBrowser} = ReportApiCalls();
    const location = useLocation();
    const history = useHistory();
    const {getDefaultConfiguration, correctConfigurations, verifyConfiguration, isLMS} = useSynLMSConfiguration();



    const [currQueDisplay, setCurrQueDisplay] = useState(1);


    const [focusMCElem, setFocusMCElem] = useState(-1);
    const [focusSAElem, setFocusSAElem] = useState(-1);
    const [focusTFElem, setFocusTFElem] = useState(-1);
    const [focusFITBElem, setFocusFITBElem] = useState(-1);
    const [focusCIElem, setFocusCIElem] = useState(-1);
    const [focusMHElem, setFocusMHElem] = useState(-1);

    const [setSaveExit, getSaveExit] = useLocalStorageNew("saveExit", false);
    const [setHostResource, getHostResource] = useLocalStorageNew(window.location.hostname, {});
    const [isSaving, setIsSaving] = useState(false);
    const [isAutoSaving, setIsAutoSaving] = useState(null);
    const [saveBtnDisabled, setSaveBtnDisabled] = useState(false);
    const [dataLoading, setDataLoading] = useState(true);

    const [savedActivity, setSavedActivity] = useState({});
    const [draftActivity, setDraftActivity] = useState({});
    const [editorView, setEditorView] = useState(ACTIVITY_EDITOR_VIEW.QUESTION_EDITING);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [courseList, setCourseList] = useState([]);


    const setQuestions = (questions) => {
        const copy = JSON.parse(JSON.stringify(draftActivity));
        copy.questions = questions;
        setDraftActivity(copy);
    }


    const {checkAnyQuestionIsLoading} = useImageLoaderManager(draftActivity.questions, setQuestions);

    const loadCourse = async () => {
        const {intType="", idpType=""} = parseToken();
        const courses = await getCourseByUser(idpType, intType);
        const options = courses.map(course => ({
            value: course.courseId,
            label: course.courseName,
            code: course.courseCode,
            isLmsCourse: !!course.index3Pk,
            lmsCourseId: removePrefixNew(!!course.index3Pk ? course.index3Pk : "")
        }));
        setCourseList(options);

        return options;
    }

    const hasUnsavedChanges = useMemo(
        () => JSON.stringify(draftActivity) !== JSON.stringify(savedActivity) && getSaveExit() !== true,
        [draftActivity, getSaveExit, savedActivity],
    );

    const {
        showConfirm: alertShow,
        confirmationModal: leaveConfirmationModal,
    } = useNavigationGuard({
        hasUnsavedChanges,
        onBypass: () => {
            setSaveExit(false);
        },
    });

    // useEffect(() => {
    //     switch(questions[currQueDisplay-1].questionType) {
    //         case QUESTION_TYPES.MCSS.name:
    //             if(focusMCElem !== -1) {
    //                 document.getElementsByName("question-text")[focusMCElem].focus();
    //                 setFocusMCElem(-1);
    //             }
    //             break;
    //         case QUESTION_TYPES.SA.name:
    //         case QUESTION_TYPES.IB.name:
    //         case QUESTION_TYPES.RETRO.name:
    //         case QUESTION_TYPES.BS.name:
    //             if(focusSAElem !== -1) {
    //                 document.getElementsByName("question-text")[focusSAElem].focus();
    //                 setFocusSAElem(-1);
    //             }
    //             break;
    //         case QUESTION_TYPES.TF.name:
    //             if(focusTFElem !== -1) {
    //                 document.getElementsByName("question-text")[focusTFElem].focus();
    //                 setFocusTFElem(-1);
    //             }
    //             break;
    //         case QUESTION_TYPES.FITB.name:
    //             if(focusFITBElem !== -1) {
    //                 if(focusFITBElem === 0) {
    //                     document.getElementsByClassName("notranslate public-DraftEditor-content")[focusFITBElem].focus();
    //                 } else {
    //                     document.getElementsByName("question-text")[focusFITBElem-1].focus();
    //                 }
    //                 setFocusFITBElem(-1);
    //             }
    //             break;
    //         case QUESTION_TYPES.CI.name:
    //             if(focusCIElem !== -1) {
    //                 document.getElementsByName("question-text")[focusCIElem].focus();
    //                 setFocusCIElem(-1);
    //             }
    //             break;
    //         case QUESTION_TYPES.MH.name:
    //             if (focusMHElem !== -1) {
    //                 console.log(focusMHElem);
    //                 document.getElementsByName("question-text")[focusMHElem].focus();
    //                 setFocusMHElem(-1);
    //             }
    //             break;
    //     }
    // }, [currQueDisplay, focusMCElem, focusSAElem, focusTFElem, focusFITBElem, focusCIElem, focusMHElem]);

    const validatePoll = (draft, focusError = true) => {
        if (!validateText(draft.pollTitle, POLL_TITLE_LENGTH)) {
            if (focusError) {
                notifyError(ACTIVITY_TITLE_ERROR);
                document.getElementsByName("pollTitle")[0].focus();
            }
            return false;
        }

        if (draft.pollType !== POLL_TYPE.ATTENDANCE && !draft.hasOwnProperty("gradeSchema")) {
            notifyError(GRADE_SCHEMA_MISSING_ERROR);
            setEditorView(ACTIVITY_EDITOR_VIEW.OVERVIEW);
            return false;
        }

        if (draft.syncLmsOption !== SYNC_LMS_OPTIONS.EMBEDDED
            && draft.audienceRestriction === AUDIENCE_RESTRICTION.REGISTERED
            && !draft.courseId
        ) {
            setEditorView(ACTIVITY_EDITOR_VIEW.CONFIGURATION);
            notifyError(SELECT_COURSE_MESSAGE);
            return false;
        }


        let i = 0;
        for (let q of draft.questions) {
            i++;
            if (getQuestionWeightage(q)> QUESTION_MAX_POINTS) {
                if (focusError) {
                    let errorWithQuestion = QUESTION + " " + i + ": " + QUESTION_MAX_POINTS_ERROR;
                    notifyError(errorWithQuestion);
                    setCurrQueDisplay(q.serialNo);
                    setEditorView(draft.pollType === POLL_TYPE.ATTENDANCE
                        ? ACTIVITY_EDITOR_VIEW.ATTENDANCE_EDITING
                        : ACTIVITY_EDITOR_VIEW.QUESTION_EDITING
                    );
                }
                return false;
            }
        }

        let index = 0;
        for (let q of draft.questions) {
            index++;
            if (focusError) {
                setCurrQueDisplay(q.serialNo);
            }

            let {quesError, elemIndex} = questionError(q, draft.pollType, draft.gradeSchema);
            switch (q.questionType) {
                case QUESTION_TYPES.MCSS.name:
                    if (focusError) setFocusMCElem(elemIndex);
                    break;
                case QUESTION_TYPES.SA.name:
                case QUESTION_TYPES.IB.name:
                case QUESTION_TYPES.RETRO.name:
                case QUESTION_TYPES.BS.name:
                    if (focusError) setFocusSAElem(elemIndex);
                    break;
                case QUESTION_TYPES.TF.name:
                    if (focusError) setFocusTFElem(elemIndex);
                    break;
                case QUESTION_TYPES.FITB.name:
                    if (focusError) {
                        setTimeout(() => {
                            setFocusFITBElem(elemIndex);
                        }, 100);
                    }
                    break;
                case QUESTION_TYPES.CI.name:
                    if (focusError) setFocusCIElem(elemIndex);
                case QUESTION_TYPES.MH.name:
                    if (focusError) setFocusMHElem(elemIndex);
                    break;
            }

            if (quesError) {
                if (focusError) {
                    let errorWithQuestion = QUESTION + " " + index + ": " + quesError;
                    // setQuestions(chooseQuestion(q.serialNo, questions));
                    setCurrQueDisplay(q.serialNo);
                    setEditorView(draft.pollType === POLL_TYPE.ATTENDANCE
                        ? ACTIVITY_EDITOR_VIEW.ATTENDANCE_EDITING
                        : ACTIVITY_EDITOR_VIEW.QUESTION_EDITING
                    );
                    notifyError(errorWithQuestion);
                }
                return false;
            }
        }
        return true;
    };

    const editPoll = async (updatedQuestions = []) => {

        let generatedTitle = generateDefaultPollTitle();
        let pollToAdd = JSON.parse(JSON.stringify(draftActivity));
        let questionsCopy = updatedQuestions && updatedQuestions.length > 0 ? JSON.parse(JSON.stringify(updatedQuestions)) : pollToAdd.questions;
        for (const que of questionsCopy) {
            trimLineBreakerInQuestion(que);
        }

        if (pollToAdd.pollType !== POLL_TYPE.ATTENDANCE) {
            pollToAdd.questions = trimQuestion(questionsCopy, draftActivity.gradeSchema);
        }
        pollToAdd.pollTitle = !!pollToAdd.pollTitle ? pollToAdd.pollTitle : generatedTitle;
        pollToAdd = correctConfigurations(pollToAdd);

        let result = await updateAndPublish(pollToAdd, false);
        if (!result) {
            return false;
        }

        let {published={}} = result;
        published = !!published ? published : {};
        const {isValid, pk, sk, totalQuestions} = published;

        if (!!isValid) {
            takeScreenshotsNew(
                removePrefixNew(pk),
                removePrefixNew(sk),
                isShareByQuestionActivity(published),
                Array.from({ length: totalQuestions }, (_, i) => ({ serialNo: i + 1 }))
            );
        }

        window.onbeforeunload = undefined;

        let copy = JSON.parse(JSON.stringify(draftActivity));
        if (pollToAdd.pollTitle !== draftActivity.pollTitle
            || (updatedQuestions && updatedQuestions.length > 0)
        ) {

            if (pollToAdd.pollTitle !== draftActivity.pollTitle) {
                copy.pollTitle = pollToAdd.pollTitle;
            }

            if (updatedQuestions && updatedQuestions.length > 0) {
                copy.questions = updatedQuestions;
            }

            setDraftActivity(JSON.parse(JSON.stringify(copy)));
            setSavedActivity(copy);
        } else {
            setSavedActivity(copy);
        }
        return true;
    };

    const editPollClose = async () => {
        let pollToAdd = JSON.parse(JSON.stringify(draftActivity));
        let questionsCopy = pollToAdd.questions;

        if (pollToAdd.pollType !== POLL_TYPE.ATTENDANCE) {
            questionsCopy = trimQuestion(questionsCopy, draftActivity.gradeSchema);
        }

        for (const que of questionsCopy) {
            trimLineBreakerInQuestion(que);
        }
        pollToAdd.questions = questionsCopy;
        pollToAdd = correctConfigurations(pollToAdd);


        if (!validatePoll(pollToAdd)) {
            return;
        }


        let error = verifyConfiguration(pollToAdd);
        if (!!error) {
            notifyError(error);
            setEditorView(ACTIVITY_EDITOR_VIEW.OVERVIEW);
            return;
        }

        setIsSaving(true);
        updateAndPublish(pollToAdd).then((result) => {
            if (!result) {
                return;
            }

            let {draft={}, published={}} = result;
            published = !!published ? published : {};
            const {isValid, pk, sk, totalQuestions} = published;

            if (!!isValid) {
                takeScreenshotsNew(
                    removePrefixNew(pk),
                    removePrefixNew(sk),
                    isShareByQuestionActivity(published),
                    Array.from({ length: totalQuestions }, (_, i) => ({ serialNo: i + 1 }))
                );
            }

            pollToAdd.syncLms = draft.syncLms;
            pollToAdd.syncLmsOption = draft.syncLmsOption;
            pollToAdd.lmsHomeUrl = draft.lmsHomeUrl;
            pollToAdd.audienceRestriction = draft.audienceRestriction;
            pollToAdd.courseId = removePrefix(draft.courseId);

            setSavedActivity(pollToAdd);
            setDraftActivity(JSON.parse(JSON.stringify(pollToAdd)));
            setSaveExit(true);
            setPollCode(result.uniqueCode);
            setEditorView(ACTIVITY_EDITOR_VIEW.SAVE_SUCCESS);
        }).finally(() => {
            setIsSaving(false);
        });

    };

    const generateDefaultTitle = () => {
        if (draftActivity.pollType === POLL_TYPE.ATTENDANCE) {
            return generateDefaultAttendanceTitle();
        } else {
            return generateDefaultPollTitle();
        }
    }

    useEffect(() => {
        const {institutionId, userId} = parseToken();
        warmUpBrowser("", "", "").then();
        let promise1 = loadUser(institutionId, userId).then(res => {
            let { settings = {} } = res;
            return settings;
        }).catch(e => {
            console.log(e);
            return {};
        });


        let shortName = getShortName();
        let promise2 = resolveShortName(shortName).catch((e) => {
            console.log(e);
            return {};
        });

        let promise3 = getPollDataFromKey(pollKey);

        const promise4 = loadCourse();

        setDataLoading(true);
        Promise.all([promise1, promise2, promise3, promise4]).then(([settings,resource, res, courseOptions]) => {
            settings = transferUserSettings(settings);
            setUserSettings(settings);

            let hostResource = getHostResource();
            hostResource.shortName = resource.shortName;
            hostResource.fullName = resource.fullName;
            hostResource.institutionId = resource.institutionId;
            hostResource.bgImgLocation = resource.bgImgLocation;
            hostResource.imageURL = resource.imageURL;
            hostResource.logoImageURL = resource.logoImageURL;
            hostResource.ssoConfig = resource.ssoConfig;
            hostResource.platformSetting = resource.platformSetting;
            hostResource.evpVideoApiUrl = resource.evpVideoApiUrl;
            hostResource.privateEVPLink = resource.privateEVPLink;
            setHostResource(hostResource);


            for (const question of res.questions) {
                if (question.questionType === QUESTION_TYPES.MH.name && !question.correctAnswers) {
                    question.correctAnswers = question.optionsMap;
                }
            }
            let activity = {};
            activity.pollKey = pollKey;
            activity.pollTitle = !!res.pollTitle ? res.pollTitle : generateDefaultTitle();
            activity.pollType = res.pollType;
            activity.gradeSchema = res.gradeSchema;
            activity.pollShareMode = res.hasOwnProperty("pollShareMode") ? res.pollShareMode : POLL_SHARE_MODE.UNKNOWN;
            activity.pollDescription = res.pollDescription;
            activity.pollTimeLimit = res.hasOwnProperty("pollTimeLimit") ? res.pollTimeLimit : settings[USER_SETTINGS.POLL_DURATION];
            activity.pollBreakDuration = res.hasOwnProperty("pollBreakDuration") ? res.pollBreakDuration : settings[USER_SETTINGS.POLL_BREAK_DURATION];
            activity.getReadyAllTimeLimit = res.hasOwnProperty("getReadyAllTimeLimit") ? res.getReadyAllTimeLimit : settings[USER_SETTINGS.POLL_COUNTDOWN];
            activity.recordAttempt = res.hasOwnProperty("recordAttempt") ? res.recordAttempt : settings[USER_SETTINGS.POLL_RECORD_ATTEMPTS];
            activity.lmsAttempt = res.hasOwnProperty("lmsAttempt") ? res.lmsAttempt : settings[USER_SETTINGS.POLL_LMS_SYNC];
            activity.maxAttempts = res.hasOwnProperty("maxAttempts") ? res.maxAttempts : settings[USER_SETTINGS.POLL_MAX_ATTEMPTS];
            activity.showAnswerOnViewer = res.hasOwnProperty("showAnswerOnViewer") ? res.showAnswerOnViewer : settings[USER_SETTINGS.POLL_SHOW_CORRECT_ANS];
            activity.audienceRestriction = getActivityAudienceRestriction(res, settings);
            activity.pptAutoShare = res.hasOwnProperty("pptAutoShare") ? res.pptAutoShare : settings[USER_SETTINGS.PPT_AUTO_SHARE];
            activity.manualEnd = res.hasOwnProperty("manualEnd") ? res.manualEnd : settings[USER_SETTINGS.ATTENDANCE_MANUAL_END];
            activity.lmsHomeUrl = res.lmsHomeUrl;
            activity.LMSColumnId = res.LMSColumnId;
            activity.lmsRedirectUrl = res.lmsRedirectUrl;
            activity.D2LModuleId = res.D2LModuleId;
            activity.moodleSectionId = res.moodleSectionId;
            activity.courseId = removePrefix(res.courseId);



            if (res.hasOwnProperty("syncLms")) {
                activity.syncLms = res.syncLms;
                activity.syncLmsOption = res.syncLmsOption;
            }

            // else {
            //     const {syncLms, syncLmsOption, courseId, audienceRestriction} = getDefaultConfiguration(courseOptions);
            //     activity.syncLms = syncLms;
            //     activity.syncLmsOption = syncLmsOption;
            //     activity.courseId = courseId;
            //     activity.audienceRestriction = !!audienceRestriction ? audienceRestriction : activity.audienceRestriction;
            // }


            if (res.pollType === POLL_TYPE.ATTENDANCE) {
                if (!res.hasOwnProperty("questions") || !res.questions.length || res.questions[0].questionType !== QUESTION_TYPES.SA.name) {
                    const qs = addQuestion([], QUESTION_TYPES.SA.name, userSettings, false, POLL_TYPE.ATTENDANCE);
                    activity.questions = qs;
                } else {
                    activity.questions = res.questions;
                }

                activity.geofence = res.hasOwnProperty("geofence") ? res.geofence : {};
                activity.attendanceDuration = res.hasOwnProperty("attendanceDuration") ? res.attendanceDuration : settings[USER_SETTINGS.ATTENDANCE_DURATION];
                setEditorView(isLMS()
                    ? (!!verifyConfiguration(activity) ? ACTIVITY_EDITOR_VIEW.OVERVIEW : ACTIVITY_EDITOR_VIEW.ATTENDANCE_EDITING)
                    : ACTIVITY_EDITOR_VIEW.ATTENDANCE_EDITING);
            } else {
                setBlankRestriction(res.questions);
                activity.questions = !!res.hasOwnProperty("questions") && !!res.questions.length ? res.questions : [{serialNo: 1}];
                setEditorView(!!activity.gradeSchema ? ACTIVITY_EDITOR_VIEW.QUESTION_EDITING : ACTIVITY_EDITOR_VIEW.OVERVIEW);
            }

            if (location?.state?.view === "configuration") {
                setEditorView(ACTIVITY_EDITOR_VIEW.CONFIGURATION);
            }

            setSavedActivity(activity);
            setDraftActivity(JSON.parse(JSON.stringify(activity)));

            updateCreateMode(res.pollType === POLL_TYPE.ATTENDANCE ? POLL_TYPE.ATTENDANCE : POLL_TYPE.MERGED_POLL);
        }).catch(e => {
            console.log(e);
        }).finally(() => setDataLoading(false));

    }, []);

    useEffect(() => {
        return () => {
            window.onbeforeunload = undefined;
        }
    }, []);


    useEffect(() => {
        if (draftActivity.pollType === POLL_TYPE.MERGED_POLL) {
            if (!draftActivity.gradeSchema
                || !draftActivity.questions
                || !draftActivity.questions.length
                || !draftActivity.questions.filter(q => !!q.questionType).length
            ) {
                setSaveBtnDisabled(true);
            } else {
                setSaveBtnDisabled(false);
            }

        }
    }, [draftActivity]);

    useEffect(() => {
        if (!!alertShow || !!isSaving || !!showDeleteModal) {
            return;
        }
        if (draftActivity.pollType === POLL_TYPE.ATTENDANCE) {
            return;
        }

        if (checkAnyQuestionIsLoading()) {
            return;
        }

        const interval = setInterval(() => {
            if (JSON.stringify(draftActivity) !== JSON.stringify(savedActivity)) {
                setIsAutoSaving(true);
                editPoll().finally(() => {
                    setIsAutoSaving(false);
                });
            }
        }, 10000);

        return () => {
            if (!!interval) {
                clearInterval(interval);
            }
        }
    }, [draftActivity, savedActivity, alertShow, showDeleteModal, isSaving]);

    const deletePollConfig = {
        title: DELETE_ACTIVITY,
        okText: MODAL_DELETE_TEXT,
        cancelText: MODAL_CANCEL_TEXT,
        submit: () => {
            softDeleteDraftPoll(pollKey, draftActivity.pollType).then(() => {
                if (history.length > 2) {
                    history.goBack();
                } else {
                    history.push(HOME_PATH);
                }
            });
        },
        close: () => {
            setShowDeleteModal(false);
        },
    };


    if (editorView === ACTIVITY_EDITOR_VIEW.SAVE_SUCCESS) {
        return (
            <PPTActivitySaved pollKey={pollKey} pollCode={pollCode} savedActivity={savedActivity}/>
        );
    }else if (editorView === ACTIVITY_EDITOR_VIEW.IMPORT_QUESTIONS) {
        return (
            <ActivityEditorImportQuestions
                setEditorView={setEditorView}
                draftActivity={draftActivity}
                setDraftActivity={setDraftActivity}
                courseList={courseList}
                userSettings={userSettings}
            />
        );
    }

    return (
        <>
            {leaveConfirmationModal}

            <YuJaGeneralAlert
                show={showDeleteModal}
                setModalShow={setShowDeleteModal}
                content={DELETE_ACTIVITY_MODAL_BODY}
                config={deletePollConfig}
                AlertType={MODAL_DELETE_TEXT}
            />

            <div className={`${classes.parentContainer} ${classes.gridLayout}`}>
                <ActivityEditorTitleContainer
                    generateTitle={generateDefaultTitle}
                    dataLoading={dataLoading}
                    draftActivity={draftActivity}
                    setDraftActivity={setDraftActivity}
                    userSettings={userSettings}
                    currQueDisplay={currQueDisplay}
                    setCurrQueDisplay={setCurrQueDisplay}
                    isAutoSaving={isAutoSaving}
                    isSaving={isSaving}
                    handleSave={editPollClose}
                    setShowDeleteModal={setShowDeleteModal}
                    saveBtnDisabled={isAutoSaving || isSaving || saveBtnDisabled}
                    editorView={editorView}
                    setEditorView={setEditorView}
                />

                <ActivityEditorDashboard
                    dataLoading={dataLoading}
                    editorView={editorView}
                    setEditorView={setEditorView}
                    draftActivity={draftActivity}
                    setQuestions={setQuestions}
                    currQueDisplay={currQueDisplay}
                    setCurrQueDisplay={setCurrQueDisplay}
                    userSettings={userSettings}
                />

                <ActivityEditorMainView
                    userSettings={userSettings}
                    dataLoading={dataLoading}
                    editorView={editorView}
                    setEditorView={setEditorView}
                    draftActivity={draftActivity}
                    setDraftActivity={setDraftActivity}
                    currQueDisplay={currQueDisplay}
                    setCurrQueDisplay={setCurrQueDisplay}
                    savePoll={editPoll}
                    courseList={courseList}
                />
            </div>
        </>
    );
}